import { createSelector } from 'reselect'
import moment from 'moment'
import { getOffset } from 'selectors/timeOffset'

export const getRelativeDateTimestamp = (state, props) => {
  return props.timestamp
}

export default () => createSelector(
  [getRelativeDateTimestamp, getOffset],
  (timestamp, timeOffset) => {
    if (timestamp == null) return timestamp

    const timestampMoment = moment(timestamp)

    timestampMoment.add(timeOffset, 'ms')

    return {
      dateMoment: timestampMoment
    }
  }
)
